<template>
  <div v-if="data?.collection?.length && data.totals.pages > 1" class="loyaltyPagination">
    <button v-if="currentPage > 1" medium secondary @click="emit('previousResults')" class="loyaltyPagination__Buttons loyaltyPagination__PreviousButton">
      <p>{{ $t('previous') }}</p>
      <Icon name="back" />
    </button>

    <div v-if="data?.totals.pages" class="loyaltyPagination__Pages" :class="{'insufficientPages': data.totals.pages < 4}">
      <button 
        v-for="page in data.totals.pages"
        @click="goToPage(page)" 
        :class="{
          'isActive': currentPage == page,
          'isVisible': page == currentPage || page - 1 == currentPage || page + 1 === currentPage 
        }"
        class="loyaltyPagination__Page"
      >
        {{ page }}
      </button>
    </div>

    <button v-if="data.more_records" medium secondary @click="emit('nextResults')" class="loyaltyPagination__Buttons loyaltyPagination__NextButton">
      <p>{{ $t('next') }}</p>
      <Icon name="back" />
    </button>
  </div>
</template>

<script setup>
  const props = defineProps({
    data: {},
    currentPage: '',
  })

  const emit = defineEmits(['previousResults', 'nextResults', 'goToPage']);

  function goToPage(page) { emit('goToPage', page)}
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_loyaltyPagination.scss');
</style>